<template>
  <div class="UserInfo">
    <van-nav-bar
      title="个人资料"
      fixed
      border
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
      <template #right>
			<van-icon name="success" size="22px"/>
      </template>
    </van-nav-bar>
    <van-cell-group class="self">
      <van-cell class="name">
        <template slot="icon">
          <van-image class="err-image-header" :src="attach_url+userInfo.u_headportrait" />
        </template>
        <template slot="title">
          <span>{{friend_name}}</span>
          <van-icon name="static/icon/man.png" v-if="userInfo.u_sex === 1" />
          <van-icon name="static/icon/woman.png" v-else-if="userInfo.u_sex === 0" />
          <br />
          <span>{{userFriend.f_name ? userInfo.u_nickname:''}}</span>
        </template>
        <template slot="label">
          <span>账号：{{userInfo.u_login_id}}</span>
        </template>
      </van-cell>

      <van-cell>
        <template slot="icon">
          <van-icon name="static/icon/biaoqian.png" />
        </template>

        <template slot="title">
          <span class="custom-title">个性签名</span>
        </template>

        <template slot="label">
          <span>{{userInfo.u_signature}}</span>
        </template>
      </van-cell>

      <van-cell>
        <template slot="icon">
          <van-icon name="static/icon/qwer.png" />
        </template>

        <template slot="title">
          <span class="custom-title">邀请人：{{userInfo.u_inviter_id}}</span>
        </template>
      </van-cell>
    </van-cell-group>

    <van-button block hairline type="info" @click="onClickSendMsg()" :style="{'margin-top':'10px'}">发消息</van-button>
  </div>
</template>

<script>
export default {
  name: "UserInfo",
  data() {
    return {
      userInfo: [],
      userFriend: [],
      friend_id: "",
      u_login_id: "",
      attach_url: this.Conf.serverPre,
      path: {
        url: "",
        active: ""
      },
      friend_name: "",
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token")
    };
  },
  methods: {
    loadData() {
      var params = {
        u_id: this.u_id,
        friend_id: this.friend_id,
        token: this.token
      };
      var url =
        this.Conf.serverUrl +
        "User/getFriendInfoById" +
        "?num=" +
        Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          this.userInfo = response.data.result;
          this.userFriend = response.data.userFriend;
          this.friend_name = this.userFriend.f_name
            ? this.userFriend.f_name
            : this.userInfo.u_nickname;
        })
        .catch(error => {});
    },
    // 返回
    onClickLeft() {
      this.$router.push({
        name: this.path.url ? this.path.url : localStorage.getItem("pathurl"),
        query: {
          active: this.path.active
            ? this.path.active
            : localStorage.getItem("active"),
          friend_id: this.friend_id,
          friend_name: this.friend_name,
          // ug_id : this.ug_id   
          //   ? this.friend_name
          //   : this.userInfo.u_login_id,
          ug_id: this.ug_id
        }
      });
    },

    // 设置
    onClickRight() {
      localStorage.setItem("pathurl", this.path.url);
      localStorage.setItem("active", this.path.active);
      this.$router.push({
        name: "UserInfoSet",
        query: {
          friend_id: this.friend_id
        }
      });
    },
    // 发送消息
    onClickSendMsg() {
      this.$router.push({
        name: "Chatroom",
        query: {
          friend_id: this.friend_id,
          friend_name: this.friend_name
            ? this.friend_name
            : this.userInfo.u_login_id
        }
      });
    },
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		}
  },
  created() {
		this.getStateConfigs();
    var query = this.$route.query;
    this.friend_id = query.friend_id;
    // this.friend_name = query.friend_name;
    // this.u_login_id = query.u_login_id;
    this.path.url = query.url;
    this.path.active = query.active;
    this.ug_id = query.ug_id;
    this.loadData();
  }
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/User/UserInfo.vue